import { render } from "./UsageStatusSection.vue?vue&type=template&id=6ad5d4a1"
import script from "./UsageStatusSection.vue?vue&type=script&lang=js"
export * from "./UsageStatusSection.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src426064190/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__